import {AuthenticationDetails, CognitoUser, CognitoUserPool, CognitoUserAttribute} from "amazon-cognito-identity-js";
import jwt_decode from "jwt-decode";

export default function Authentication() {

    /********************************************************/
    if (Authentication.prototype._singletonInstance) return Authentication.prototype._singletonInstance;
    Authentication.prototype._singletonInstance = this;
    /********************************************************/

    const poolData = {
        UserPoolId: process.env.REACT_APP_USER_POOL_ID,
        ClientId: process.env.REACT_APP_CLIENT_ID,
    };


    this.authenticate = function (username, password, afterSuccessCallback, failureCallback, requiresVerificationCallback) {
        const authenticationData = {
            Username: username,
            Password: password,
        };
        const authenticationDetails = new AuthenticationDetails(
            authenticationData
        );

        const userPool = new CognitoUserPool(poolData);

        const userData = {
            Username: username,
            Pool: userPool,
        };

        let cognitoUser = new CognitoUser(userData);

        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                afterSuccessCallback(result);
            },
            onFailure: function (err) {
                if (err.code === "UserNotConfirmedException") {
                    requiresVerificationCallback();
                } else {
                    failureCallback(err);
                }
            }
        });
    };

    this.signUp = function (username, password, successCallback, failureCallback) {
        const userPool = new CognitoUserPool(poolData);

        const dataEmail = {
            Name: 'email',
            Value: username,
        };

        const attributeEmail = new CognitoUserAttribute(dataEmail);

        let attributeList = [];
        attributeList.push(attributeEmail);

        userPool.signUp(username, password, attributeList, null, function (
            err,
            result
        ) {
            if (err) {
                if (err.message.toUpperCase().includes('Invalid business email'.toUpperCase())) {
                    failureCallback({message: 'Please use a business email'})
                } else {
                    failureCallback(err);
                }
                return;
            }
            successCallback(result);
        });
    };

    this.resendCode = function (email, successCallback, failureCallback) {
        const userPool = new CognitoUserPool(poolData);
        const userData = {
            Username: email,
            Pool: userPool,
        };

        let cognitoUser = new CognitoUser(userData);

        cognitoUser.resendConfirmationCode(function (err, result) {
            if (err) {
                failureCallback(err);
                return;
            }
            successCallback(result);
        });
    };

    this.verify = function (username, code, successCallback, failureCallback) {
        const userPool = new CognitoUserPool(poolData);
        const userData = {
            Username: username,
            Pool: userPool,
        };

        let cognitoUser = new CognitoUser(userData);
        cognitoUser.confirmRegistration(code, true, function (err, result) {
            if (err) {
                failureCallback(err);
                return;
            }
            successCallback(result);
        });
    };

    this.forgottenPassword = function (email, successCallback, failureCallback) {
        const userPool = new CognitoUserPool(poolData);
        const userData = {
            Username: email,
            Pool: userPool,
        };

        const cognitoUser = new CognitoUser(userData);
        cognitoUser.forgotPassword({
            onSuccess: function (data) {
                successCallback(data);
            },
            onFailure: function (err) {
                failureCallback(err);
            },
        });
    };

    this.resetPassword = function (email, verificationCode, newPassword, successCallback, failureCallback) {
        const userPool = new CognitoUserPool(poolData);
        const userData = {
            Username: email,
            Pool: userPool,
        };

        let cognitoUser = new CognitoUser(userData);

        cognitoUser.confirmPassword(verificationCode, newPassword, {
            onSuccess() {
                successCallback();
            },
            onFailure(err) {
                failureCallback(err);
            },
        });
    };

    this.isLoggedIn = function () {
        const userPool = new CognitoUserPool(poolData);
        const cognitoUser = userPool.getCurrentUser();

        let valid = false;

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {
                if (err) {
                    return false;
                }

                valid = session.isValid();
            });
        } else {
            valid = false;
        }

        return valid;
    };

    this.isAdmin = function () {
        const userPool = new CognitoUserPool(poolData);
        const cognitoUser = userPool.getCurrentUser();

        let isAdmin = false;

        if (cognitoUser != null){
            cognitoUser.getSession(function (err) {
                if (err) {
                    return false;
                }
                try {
                    let token = cognitoUser.signInUserSession.idToken.jwtToken;
                    let groups = jwt_decode(token)['cognito:groups'];
                    for (let i=0; i<groups.length; i++) {
                        if (groups[i] === "admin") {
                            isAdmin = true;
                            break;
                        }
                    }
                } catch (error){
                }
            });
            return isAdmin;
        }
    };

    this.logout = function (successCallback) {
        const userPool = new CognitoUserPool(poolData);
        const cognitoUser = userPool.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.signOut();
        }

        successCallback();
    };

    this.fetchToken = function (callback) {
        var userPool = new CognitoUserPool(poolData);
        var cognitoUser = userPool.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function(err, session) {
                if (err || !session.isValid()) {
                    callback('');
                } else {
                    callback(session.getIdToken().getJwtToken());
                }
            });
        } else {
            callback('');
        }
    }
}